<template>
  <div>
    <div class="width100 margin-auto backgroudFFF margin-top15">
      <el-empty
        :image="require('@/assets/barsvg/icon／qsy／jsz.png')"
        :image-size="200"
        description="模块功能升级中，敬请期待"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          模块升级中
        </p></el-empty
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
    };
  },
  mounted() {},
};
</script>
<style scoped>
.heightempty {
  height: 88vh;
}
</style>